import React, { useState } from "react";
import {
  AiFillTag,
  AiOutlineClose,
  AiOutlineMenu,
  AiOutlineSearch,
} from "react-icons/ai";
import { BiWallet } from "react-icons/bi";
import { BsFillCartFill, BsFillSaveFill } from "react-icons/bs";
import { FaUserFriends } from "react-icons/fa";

import { MdFavorite, MdHelp } from "react-icons/md";
import { TbTruckDelivery } from "react-icons/tb";

function NavBar({cat}) {
  const [text, setText] = useState('')
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <div className="   max-w-full mx-auto  flex  justify-between items-center p-4  border-b-2 border-gray-100 shadow-lg">

      <div className="flex items-center ">
        <div>
          <AiOutlineMenu
            size={20}
            onClick={() => setOpenMenu(true)}
            className="cursor-pointer mt-1 "
          />
        </div>
        <h1 className="text-2xl sm:text-2xl lg:text-3xl px-3 ">
          Best <span className="font-bold">Eats</span>
        </h1>
        <div className="hidden lg:flex items-center  bg-gray-200 rounded-full text-[14px] p-1">
          <p className="bg-[#003] text-white rounded-full p-2"> Dilivery</p>
          <p className="p-2">Pickup</p>
        </div>
      </div>

      {/* search box*/}
      <div className="flex items-center mr-7 ml-7 bg-gray-200 rounded-full px-2 w-[200px] sm:w-[400px] lg:w-[600px]">
        <AiOutlineSearch size={25} />
        <input
          className="bg-transparent focus:outline-none text-xl font-serif text-gray-100 p-1 w-full"
          type={text}
          placeholder="Search foods"
          onChange={(e=>setText(e.target.value))}
        />
      </div>

      {/* Cart*/}

      <button className="bg-[#003] ml-[20px] text-white hidden md:flex py-2 px-4 items-center rounded-full relative">
        <div className="absolute ml-1 mt-1 -top-1 h-4 w-4 rounded-full bg-black flex items-center justify-center">
          <span className="text-white text-sm font-bold">{cat}</span>
        </div>
        <BsFillCartFill size={20} className="mr-2" />
        Cart
      </button>


      {/* Mobile menu*/}

      <div
        className={
          openMenu
            ? `fixed bg-[#000]/60 bg-gradient-to-b w-full h-screen top-0 left-0 z-10 duration-200 ease-in-out`
            : ""
        }
      >
        <div
          className={
            openMenu
              ? "fixed bg-slate-50 h-screen w-[250px] md:w-[300px] top-0 left-0 z-10 rounded duration-300"
              : "fixed bg-slate-50 h-screen w-[250px] md:w-[300px] top-0 left-[-100%] z-10 rounded duration-600"
          }
        >
          <AiOutlineClose
            size={20}
            onClick={() => setOpenMenu(false)}
            className="absolute right-4 top-4 cursor-pointer"
          />
          <nav>
            <h1 className="text-2xl p-4 mb-4  ">
              Best <span className="font-bold">Eats</span>{" "}
            </h1>
            <ul className="flex flex-col p-4 text-gray-800 font-medium font-serif">
              <li className="cursor-pointer hover:scale-105 flex items-center text-[18px] mb-4">
                <TbTruckDelivery className="mr-4 " /> Orders
              </li>
              <li className="cursor-pointer hover:scale-105 flex items-center text-[18px]  mb-4">
                <MdFavorite className="mr-4 " /> Favorities
              </li>
              <li className="cursor-pointer hover:scale-105 flex items-center text-[18px]  mb-4">
                <BiWallet className="mr-4 " /> Wallet
              </li>
              <li className="cursor-pointer hover:scale-105 flex items-center text-[18px]  mb-4">
                <MdHelp className="mr-4 " /> Help
              </li>
              <li className="cursor-pointer hover:scale-105 flex items-center text-[18px]  mb-4">
                <AiFillTag className="mr-4 " /> Promotion
              </li>
              <li className="cursor-pointer hover:scale-105 flex items-center text-[18px]  mb-4">
                <BsFillSaveFill className="mr-4 " /> Best One
              </li>
              <li className="cursor-pointer hover:scale-105 flex items-center text-[18px]  mb-4">
                <FaUserFriends className="mr-4 " /> Invite Friends
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
